import React from 'react';
import MainHeaderComponent from '../../components/main-header/main-header.component';
import { Link } from 'react-router-dom';
import { Loading, Search } from 'carbon-components-react';
import {
  formatCurrency,
  formatDate,
  getQueryString,
  statusColor,
} from '../../utils/common.util';
import ChequePaymentModal from './ChequePaymentModal';
import useSWR from 'swr';
import { useUrlState } from '../../utils/useUrlState';

const filters = {
  page: 1,
  skip: 0,
  limit: 10,
  search: '',
  dateFrom: '',
  dateTo: '',
};

export default function ChequePayments() {
  const [query, setQuery] = useUrlState(filters);
  const [currentPayment, setCurrentPayment] = React.useState(null);

  const {
    data: payments,
    isLoading,
    mutate,
  } = useSWR(`school/list-invoice-cheque-payment?${getQueryString(query)}`);
  const data = payments?.payments ?? [];

  return (
    <div>
      <MainHeaderComponent />

      <ChequePaymentModal
        openModal={!!currentPayment?.id}
        closeModal={() => setCurrentPayment(null)}
        payment={currentPayment}
        refreshPage={mutate}
      />

      <div className=" page-container">
        <div>
          <Link to="/admin" className="text-12 text-dark">
            Admin
          </Link>
          &nbsp;<span className="text-12">&gt;</span>&nbsp;
          <span className="text-12 text-primary font-bold">
            Cheque Payments
          </span>
        </div>

        <hr className="grey-hr mt-210 mb-10" />

        <div className="mt-15">
          <span className="h-20">Cheque Payments</span>
        </div>

        <div className="mt-10">
          <Search
            id="search"
            name="search"
            labelText=""
            value={query.search}
            onChange={(e) => setQuery({ search: e.target.value })}
            placeHolderText="Search by Cheque Number, School, Amount Paid or Date"
          />
        </div>

        <div className="mt-20 fade-in" hidden={!isLoading}>
          <Loading small={true} withOverlay={false} description="Loading..." />
        </div>

        <p
          className="text-14 mt-30 text-grey"
          hidden={isLoading || data.length > 0}
        >
          No Cheque Payments made yet
        </p>

        <div className="nm mt-20" hidden={isLoading || data.length === 0}>
          <div className="table-container">
            <table className="bx--data-table table-white">
              <thead>
                <tr>
                  <th>Payment ID</th>
                  <th>School</th>
                  <th>Invoice Number</th>
                  <th>Cheque Number</th>
                  <th>Amount Paid</th>
                  <th>Submitted by</th>
                  <th>Payment Date</th>
                  <th>Status</th>
                  <th className="text-center no-print">Action</th>
                </tr>
              </thead>
              <tbody>
                {data.map((payment) => (
                  <tr key={payment.id}>
                    <td>{payment?.id}</td>
                    <td>{payment?.school.name}</td>
                    <td>{payment?.invoiceNumber}</td>
                    <td>{payment?.chequeNumber}</td>
                    <td>{formatCurrency(payment?.amountPaid)}</td>
                    <td>
                      {payment.submittedBy?.firstName}{' '}
                      {payment.submittedBy?.lastName}
                    </td>
                    <td>{formatDate(payment?.paymentDate)}</td>
                    <td
                      className={`font-bold ${statusColor[payment?.status?.toLowerCase()]}`}
                    >
                      {payment?.status}
                    </td>
                    <td className="text-center no-print">
                      <div
                        className="link mt-5"
                        onClick={() => setCurrentPayment(payment)}
                      >
                        VIEW
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
